export default "__VITE_ASSET__42b203cb__"